module.exports = "mutation ($id: ID!) {\n  TokenDelete(id: $id) {\n    id\n  }\n}\n"